import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':workOrderId'}/getPerDiemInfo`;

export const ROUTE: RouteDefinition = `${baseRoute}/:workOrderId/getPerDiemInfo`;

export const URL = (workOrderId: number): RouteDefinition => `${baseRoute}/${workOrderId}/getPerDiemInfo`;

